$(document).ready(function(){
  $('.custom_banner_slider .custom_banner_slider_row').owlCarousel({
    loop:true,
    items:1,
    dots:false,
    nav:true,
    navText : ['<span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_92_" d="M111.213,165.004L250.607,25.607c5.858-5.858,5.858-15.355,0-21.213c-5.858-5.858-15.355-5.858-21.213,0.001  l-150,150.004C76.58,157.211,75,161.026,75,165.004c0,3.979,1.581,7.794,4.394,10.607l150,149.996  C232.322,328.536,236.161,330,240,330s7.678-1.464,10.607-4.394c5.858-5.858,5.858-15.355,0-21.213L111.213,165.004z"/><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></span>','<span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"/><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></span>']
  });
  
  $(document).on('click','.filter_sort_by_wrapper .sort_by_new_wrapp',function(event){
    event.stopPropagation();
    $(this).toggleClass('active');
  });
  
  $("body").click(function() {
    $(".filter_sort_by_wrapper .sort_by_new_wrapp").removeClass("active");
  });
  
  $(document).on('click','.filter_sort_by_wrapper .sort_by_new_wrapp .sort_by_new_opt span',function(){
    $(this).siblings('span').removeClass('selected');
    $(this).addClass('selected');
    var value = $(this).data('value');
    $(this).parents('.filter_sort_by_wrapper').find('#SortBy').val(value).trigger('change');
    $('.checkbox_for_submit_custom_value').trigger('click');
    $(this).parents('.filter_sort_by_wrapper').removeClass("active");
  });
  
  $('.filter__inner_popup').click(function(){
    $(this).toggleClass('active');
  });
  $('.filter__inner_popup .description').click(function(e){
    e.stopPropagation();
  });
  
});